<template>
  <b-card class="border border-dark shadow-none">
    <b-card-text>
      <b-container>
        <b-row
          class="mb-2"
        >
          <b-col md="4">
            <h5 class="font-weight-bolder mb-2">
              Información de las piezas
            </h5>
          </b-col>

          <!-- #region begin::Searcher -->
          <b-col md="12">
            <BasicSearcher
              :callback="handleSearch"
              placeholder="Buscar piezas"
            />
          </b-col>
          <!-- #endregion end::Searcher -->

          <template v-if="pieces.length > 0">

            <b-col md="12">
              <b-table
                :items="pieces"
                :fields="columns"
                responsive
                class="mt-2"
              >

                <!-- #region:Virtual column for index -->
                <template #cell(No)="data">
                  {{ indexFrom + data.index }}
                </template>
                <!-- #endregion:Virtual column for index -->

                <!-- #region:Virtual column for tag -->
                <template #cell(Tag)="{ item }">
                  <span class="text-nowrap">{{ item.Tag }}</span>
                </template>
                <!-- #endregion:Virtual column for tag -->

                <!-- #region:Virtual column for NoSeries -->
                <template #cell(NoSeries)="{ item }">
                  <span class="text-nowrap">{{ item.NoSeries }}</span>
                </template>
                <!-- #endregion:Virtual column for NoSeries -->

                <!-- #region:Virtual column for NoPetition -->
                <template #cell(NoPetition)="{ item }">
                  <span class="text-nowrap">{{ item.NoPetition }}</span>
                </template>
                <!-- #endregion:Virtual column for NoPetition -->

                <!-- #region:Virtual column for NoInvoice -->
                <template #cell(NoInvoice)="{ item }">
                  <span class="text-nowrap">{{ item.NoInvoice }}</span>
                </template>
                <!-- #endregion:Virtual column for NoInvoice -->

                <!-- #region:Virtual column for NoImport -->
                <template #cell(NoImport)="{ item }">
                  <span class="text-nowrap">{{ item.NoImport }}</span>
                </template>
                <!-- #endregion:Virtual column for NoImport -->

                <!-- #region:Virtual column for Condition -->
                <template #cell(Condition)="{ item }">
                  <span class="text-nowrap">{{ item.Condition }}</span>
                </template>
                <!-- #endregion:Virtual column for Condition -->

                <!-- #region:Virtual column for Availability -->
                <template #cell(Availability)="{ item }">
                  <span class="text-nowrap">
                    <h6><b-badge
                      class="ava-label"
                      :variant="getAvailabilityStyle(item.Availability)"
                    >{{ item.Availability }}
                    </b-badge>
                    </h6>
                  </span>
                </template>
                <!-- #endregion:Virtual column for Availability -->

                <!-- #region:Virtual column for Location -->
                <template #cell(Location)="{ item }">
                  <span class="text-nowrap">{{ item.Location }}</span>
                </template>
                <!-- #endregion:Virtual column for Location -->

                <!-- #region:Virtual column for ArriveDate -->
                <template #cell(ArriveDate)="{ item }">
                  <span class="text-nowrap">{{ item.ArriveDate | moment("DD/MM/YYYY") }}</span>
                </template>
                <!-- #endregion:Virtual column for ArriveDate -->

                <!-- #region:Virtual column for UnitPriceInvoiceUsd -->
                <template #cell(UnitPriceInvoiceUsd)="{ item }">
                  <span class="text-nowrap">{{ item.UnitPriceInvoiceUsd | currencyWhite }}</span>
                </template>
                <!-- #endregion:Virtual column for UnitPriceInvoiceUsd -->

                <!-- #region:Virtual column for ExchangeRate -->
                <template #cell(ExchangeRate)="{ item }">
                  <span class="text-nowrap">{{ item.Tc | currencyWhite }}</span>
                </template>
                <!-- #endregion:Virtual column for ExchangeRate -->

                <!-- #region:Virtual column for UnitPriceInvoiceMn -->
                <template #cell(UnitPriceInvoiceMn)="{ item }">
                  <span class="text-nowrap">{{ item.UnitPriceInvoiceMn | currencyWhite }}</span>
                </template>
                <!-- #endregion:Virtual column for UnitPriceInvoiceMn -->

                <!-- #region:Virtual column for CostUtility -->
                <template #cell(CostUtility)="{ item }">
                  <span class="text-nowrap">{{ item.Ccost | currencyWhite }}</span>
                </template>
                <!-- #endregion:Virtual column for CostUtility -->

                <!-- #region:Virtual column for ProvidersPriceUsd -->
                <template #cell(ProvidersPriceUsd)="{ item }">
                  <span class="text-nowrap">{{ item.ProvidersPriceUsd | currencyWhite }}</span>
                </template>
                <!-- #endregion:Virtual column for ProvidersPriceUsd -->

                <!-- #region:Virtual column for ProvidersCostingMn -->
                <template #cell(ProvidersCostingMn)="{ item }">
                  <span class="text-nowrap">{{ item.ProvidersCostingMn | currencyWhite }}</span>
                </template>
                <!-- #endregion:Virtual column for ProvidersCostingMn -->

              </b-table>
            </b-col>
          </template>

          <template v-if="pieces.length === 0 && loadingPieces === false">
            <b-col
              md="12"
              class="mt-2"
            >
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>No se encontraron piezas.</span>
                </div>
              </b-alert>
            </b-col>
          </template>
        </b-row>
      </b-container>
    </b-card-text>

    <!-- #region begin::Pagination & items per list -->
    <BasicPaginator
      v-if="pieces.length > 0"
      class="mt-2"
      :callback="handleChangePagination"
      :total-rows="totalPieces"
    />
    <!-- #endregion begin::Pagination & items per list -->

  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  BCol, BRow, BCard, BCardText, BContainer, BTable, BBadge, VBTooltip, BAlert,
} from 'bootstrap-vue'

import getError from '@/helpers/ErrorsHandler'
import BasicSearcher from '@/components/forms/BasicSearcher.vue'
import BasicPaginator from '@/components/tables/BasicPaginator.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BAlert,
    BBadge,
    BTable,
    BCardText,
    BContainer,
    BasicSearcher,
    BasicPaginator,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    query: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      perPage: 10,
      searchTerm: '',
      currentPage: 1,
      totalPieces: 0,
      loadingPieces: false,
      indexFrom: 0,
      columns: [
        {
          key: 'No',
          label: 'No.',
          thStyle: 'text-transform: none;',
          thClass: 'bg-light',
        },
        {
          key: 'Tag',
          label: 'Tag',
          thClass: this.$ability.can('read', 'Piece_tag') ? 'bg-light' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_tag') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'NoSeries',
          label: 'No. serie',
          thClass: this.$ability.can('read', 'Piece_serie') ? 'bg-light text-nowrap' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_serie') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'NoPetition',
          label: 'No. Pedimento',
          thClass: this.$ability.can('read', 'Piece_petition') ? 'bg-light text-nowrap' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_petition') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'NoInvoice',
          label: 'No. factura',
          thClass: this.$ability.can('read', 'Piece_invoice') ? 'bg-light text-nowrap' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_invoice') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'NoImport',
          label: 'No. importación',
          thClass: this.$ability.can('read', 'Piece_import') ? 'bg-light text-nowrap' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_import') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'Condition',
          label: 'Condición',
          thClass: this.$ability.can('read', 'Piece_condition') ? 'bg-light' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_condition') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'Availability',
          label: 'Disponibilidad',
          thClass: this.$ability.can('read', 'Piece_availability') ? 'bg-light' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_availability') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'Location',
          label: 'Ubicación',
          thClass: this.$ability.can('read', 'Piece_location') ? 'bg-light' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_location') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'ArriveDate',
          label: 'Fecha de llegada',
          thClass: this.$ability.can('read', 'Piece_arrival_date') ? 'bg-light text-nowrap' : 'd-none',
          tdClass: this.$ability.can('read', 'Piece_arrival_date') ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'UnitPriceInvoiceUsd',
          label: 'Precio unitario factura USD',
          thClass: this.isAdmin() ? 'bg-light' : 'd-none',
          tdClass: this.isAdmin() ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'ExchangeRate',
          label: 'Tipo de cambio',
          thClass: this.isAdmin() ? 'bg-light' : 'd-none',
          tdClass: this.isAdmin() ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'UnitPriceInvoiceMn',
          label: 'Precio unitario factura M/N',
          thClass: this.isAdmin() ? 'bg-light' : 'd-none',
          tdClass: this.isAdmin() ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'CostUtility',
          label: 'Costeo MN\'SC / Utilidad(5%) M/N',
          thClass: this.isAdmin() ? 'bg-light' : 'd-none',
          tdClass: this.isAdmin() ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'ProvidersPriceUsd',
          label: 'Precio proveedores USD',
          thClass: this.isAdmin() ? 'bg-light' : 'd-none',
          tdClass: this.isAdmin() ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
        {
          key: 'ProvidersCostingMn',
          label: 'Costeo proveedores M/N',
          thClass: this.isAdmin() ? 'bg-light' : 'd-none',
          tdClass: this.isAdmin() ? '' : 'd-none',
          thStyle: 'text-transform: none;',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getExternalPieces: 'pieces/getExternalPieces',
    }),
    /**
     * Piezas que se cagan en la lista
     */
    pieces: {
      get() { return this.getExternalPieces },
      set(value) { this.setExternalPieces(value) },
    },
  },
  async mounted() {
    this.loadProductPiecesList()
  },
  methods: {
    ...mapActions({
      loadPiecesProduct: 'pieces/loadPiecesProduct',
      setExternalPieces: 'pieces/setExternalPieces',
    }),
    handleSearch(searchTerm) {
      this.currentPage = 1
      this.searchTerm = searchTerm
      this.loadProductPiecesList()
    },
    getAvailabilityStyle(availability) {
      switch (availability) {
        case 'Disponible':
          return 'light-success'
        case 'No disponible':
          return 'light-danger'
        default:
          return 'light-primary'
      }
    },

    /**
    * Evento de paginación
    *
    * @summary Evento del componente de paginación. Establece la página actual y la cantidad
    * de registros por página
    * @param {number} currentPage - Página actual
    * @param {number} perPage - Elementos a mostrar por página
    */
    async handleChangePagination(currentPage, perPage) {
      this.currentPage = currentPage
      this.perPage = perPage
      this.loadProductPiecesList()
    },

    /**
    * Carga de registros de tipo piezas
    *
    * @summary ⁡⁢⁣⁡⁢⁢⁡⁣⁣⁡⁣⁢⁣⁡⁣⁢⁢⁡⁢⁢⁢‍Carga y establece las piezas correspondientes a un producto
    * @exception ⁡⁢⁣⁢Error de validación en la carga de registros de piezas
    */
    async loadProductPiecesList() {
      try {
        this.$swal({
          title: 'Cargando...',
          allowOutsideClick: false,
        })
        this.$swal.showLoading()
        this.loadingPieces = true

        const response = await this.loadPiecesProduct(this.loadParams())
        this.pieces = response.data.data.pieces.data
        this.totalPieces = response.data.data.pieces.total
        this.indexFrom = response.data.data.pieces.from

        this.$swal.close()
      } catch (error) {
        this.$swal.close()
        this.showToast('Error de validación', getError(error), 'danger')
      } finally {
        this.loadingPieces = false
      }
    },

    /**
    * Parámetros de carga
    *
    * @summary Devuelve los parámetros de carga de la lista
    */
    loadParams() {
      return {
        perPage: this.perPage,
        idProduct: this.product.IdProduct,
        searchTerm: this.searchTerm,
        currentPage: this.currentPage,
        ...(this.query && { query: this.query }),
      }
    },

    /**
    * Muestra un mensaje de tipo toast
    * @param {string} title - Título del mensaje
    * @param {string} text - Contenido del mensaje
    * @param {string} variant - Tipo del mensaje (warning, success, danger)
    */
    showToast(title, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title, text, variant, icon: 'BellIcon',
        },
      })
    },
    /**
     * Verifica si el usuario es administrador
     *
     * @summary Tomamos el permiso de creación de productos para verificar si el usuario es administrador
     * @returns {boolean} - Verdadero si el usuario es administrador
     */
    isAdmin() {
      return this.$ability.can('create', 'Product')
    },
  },
}
</script>

<style lang="scss" scoped>
  .feather-48{
    width: 48px;
    height: 48px;
  }
</style>
